import styled from 'styled-components';
import { ColumnData } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { spacing } from 'ui/theme';
import { StyledTable, TableWrapper } from './SimpleTable.styled';
import { TableBody } from './TableBody';
import { TableHeader } from './TableHeader';
import { TablePagination } from './TablePagination';
import { useSimpleIndexContext } from './contexts';

const StyledTableRows = styled(TableRows)`
  [data-test='full-width'] & {
    > :first-child {
      padding-left: ${spacing.layoutLRPadding};
    }

    > :last-child {
      padding-right: ${spacing.layoutLRPadding};
    }
  }
`;

type Props = {
  isError: boolean;
  isLoading: boolean;
  numLoadingRows?: number;
  pluralResourceName?: string;
  rowsColumns: ColumnData[];
  withHorizontalScroll?: boolean;
};

export const SimpleTable = ({
  isError,
  isLoading,
  numLoadingRows,
  pluralResourceName = 'resources',
  rowsColumns,
  withHorizontalScroll = false,
}: Props) => {
  const { currentRecords, hasRecords, pageSize } = useSimpleIndexContext();

  return (
    <>
      <TableWrapper withHorizontalScroll={withHorizontalScroll}>
        <StyledTable withHorizontalScroll={withHorizontalScroll}>
          <TableHeader rowsColumns={rowsColumns} />
          <TableBody
            currentRecordsLength={currentRecords.length}
            hasRecords={hasRecords}
            isError={isError}
            isLoading={isLoading}
            numColumns={rowsColumns.length}
            numRows={numLoadingRows || pageSize}
            pluralResourceName={pluralResourceName}
          >
            <StyledTableRows rows={currentRecords} columns={rowsColumns} idKey="value" />
          </TableBody>
        </StyledTable>
      </TableWrapper>
      <TablePagination />
    </>
  );
};
